import { render, staticRenderFns } from "./BoardingClassDateReportFilter.vue?vue&type=template&id=6312d728&scoped=true&"
import script from "./BoardingClassDateReportFilter.vue?vue&type=script&lang=js&"
export * from "./BoardingClassDateReportFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoardingClassDateReportFilter.vue?vue&type=style&index=0&id=6312d728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312d728",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField})
